export default "Garderhøjfortet åbnede deres 3 matematiske escape rooms i juli 2021.";